import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllTimetableApi,
  uploadTimetableApi,
  deleteTimetableApi,
} from "../../apis/scheduleAndTimetable";

export const getAllTimetable = createAsyncThunk(
  "timetable/getAll",
  async () => {
    const response = await getAllTimetableApi();
    console.log(response.data.data);

    return response.data.data;
  }
);




export const uploadTimetable = createAsyncThunk(
  "timetable/upload",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadTimetableApi(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Upload failed");
    }
  }
);

export const deleteTimetable = createAsyncThunk(
  "timetable/delete",
  async (id, { rejectWithValue }) => {
    if (!id) {
      console.error("Invalid ID:", id); // Debugging
      return rejectWithValue("Invalid ID provided for deletion");
    }
    try {
      console.log("API call to delete timetable with ID:", id); // Debugging
      await deleteTimetableApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete timetable"
      );
    }
  }
);


const timetableSlice = createSlice({
  name: "timetables",
  initialState: {
    timetables: [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.timetables = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllTimetable.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllTimetable.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.timetables = action.payload;
       
      })
      .addCase(getAllTimetable.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // upload timetable reducers
      .addCase(uploadTimetable.pending, (state) => {
        state.uploadStatus = "loading";
      })
      .addCase(uploadTimetable.fulfilled, (state,action) => {
        state.uploadStatus = "succeeded";
        state.timetables.push(action.payload);

      })
      .addCase(uploadTimetable.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.uploadError = action.payload;
      })


      // delete timetable
      .addCase(deleteTimetable.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteTimetable.fulfilled, (state, action) => {
        state.status = "succeeded";

        state.timetables = state.timetables.filter(
          (deleteStudentTimetable) => deleteStudentTimetable.id !== action.payload
        );
      })
      .addCase(deleteTimetable.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete timetable.";
      });
  },
});

export default timetableSlice.reducer;
